export enum ProductActionType {
  ShowDetails,
  SignalProduct,
  SelectedProduct,
  ShowCriterias,
}
